<template>
  <div>
    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="
        min-height: 600px;
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-12 col-md-10">
            <h1 class="display-2 text-white">Hola Usuario</h1>
            <p class="text-white mt-0 mb-5">
              Aquí puede gestionar los detalles de su ejercicio
            </p>
            <router-link to="/ejercicios" class="btn btn-info"><span>Volver a Ejercicios</span></router-link>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Detalles del ejercicio</h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent="onFormSubmit">
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative=""
                        label="Nombre"
                        placeholder="Nombre"
                        input-classes="form-control-alternative"
                        v-model="ejercicio_name"
                      />
                      <div class="form-group">
                        <label for="ejercicio_category" class="form-control-label">Categoría</label>
                        <select class="form-control form-control-alternative" id="ejercicio_category" v-model="ejercicio_category">
                          <option>pectoral</option>
                          <option>espalda</option>
                          <option>biceps</option>
                          <option>triceps</option>
                          <option>hombro</option>
                          <option>trapecio</option>
                          <option>abdominales</option>
                          <option>lumbares</option>
                          <option>piernas</option>
                          <option>cardio</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                
                <hr class="my-4" />
                <!-- Address -->
                <h6 class="heading-small text-muted mb-4">
                  Detalles
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                     <div class="col-md-12">
                      <input
                        type="file"
                        name="ejercicio_img"
                        id="ejercicio_img"
                        @change="previewImage" accept="image/*"
                      />
                      
                      <img
                        v-if="ejercicio_img != null"
                        :src="ejercicio_img"
                        class="preview"
                        alt=""
                        id="ejercicio_pic"
                      />
                    </div>
                    <div class="col-md-12">
                      <quill-editor  id="editor" conenteditable=true
                        ref="myQuillEditor"
                        :content="ejercicio_description"
                        :options="editorOption"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @ready="onEditorReady($event)"
                        @change="onEditorChange($event)"
                      />
                    </div>
                  </div>
                </div>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-md-12">
                      <br>
                      <button id="save" class="btn btn-primary btn-block">Guardar</button>
                    </div>
                  </div>
                </div>
                
                
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import  { db }  from '../../firebaseDb';
import { auth } from '../../firebaseDb';
import  { stor }  from '../../firebaseDb';

export default {
  name: "edit-ejercicio",
  props: {
        ejercicioId: {
          type: String,
          defalut: "ASD"
        },
  },
  data() {
    return {
      user: auth.currentUser,
      ejercicio_name: "Nombre ejercicio",
      ejercicio_description: "Descripción del ejercicio",
      ejercicio_img: null,
      ejercicio_category: "",
      editorOption: {
           readOnly: false,
      },
      
    };
  },
  methods: {
            onFormSubmit(event) {
                event.preventDefault()
                db.collection('ejercicios').doc(this.ejercicioId)
                .update({
                  ejercicio_name: this.ejercicio_name,
                  ejercicio_description: this.ejercicio_description,
                  ejercicio_img: this.ejercicio_img,
                  ejercicio_category: this.ejercicio_category,
                }).then(() => {
                    alert("Ejercicio actualizado con éxito!");

                }).catch((error) => {
                    console.log(error);
                });
            },
             onEditorBlur(quill) {
              console.log('editor blur!', quill)
            },
            onEditorFocus(quill) {
              console.log('editor focus!', quill)
            },
            onEditorReady(quill) {
              console.log('editor ready!', quill)
            },
            onEditorChange({ quill, html, text }) {
              console.log('editor change!', quill, html, text)
              this.ejercicio_description = html
            },
            previewImage(event){
              this.uploadValue=0;
              this.ejercicio_img = event.target.files[0];
              this.onUpload();
            },
            onUpload(){
              let img_name = this.ejercicioId+this.ejercicio_img.name.substring(this.ejercicio_img.name.length-4, this.ejercicio_img.name.length)
                const storageRef=stor.ref('ejercicios/').child(img_name).put(this.ejercicio_img);
                storageRef.on(`state_changed`,snapshot=>{
                  this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
                }, error=>{console.log(error.message)},
                  ()=>{this.uploadValue=100;
                    storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                        this.ejercicio_img =url;
                        console.log(this.img1)
                      });
                    }      
                  );
            },
  },
  created: function() {
    var self = this
    db.collection('ejercicios').doc(this.ejercicioId).get()
    .then(function(doc){
      if(doc.exists){
        try{
          let ejercicioName = doc.data().ejercicio_name
          self.ejercicio_name = ejercicioName

          let ejercicioDesc = doc.data().ejercicio_description
          self.ejercicio_description = ejercicioDesc.valueOf()
          console.log(typeof ejercicioDesc)


          let ejercicioImg = doc.data().ejercicio_img
          self.ejercicio_img = ejercicioImg

          let ejercicioCat = doc.data().ejercicio_category
          self.ejercicio_category = ejercicioCat

        }catch(error){
          console.log(error)
        }
      }
    })
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  mounted() {
    console.log('this is current quill instance object', this.editor)
  },
  
};
</script>
<style>
#editor{
  height: 500px;
}

#save{
  margin-top: 105px;
}
#ejercicio_pic{
    max-height: 128px;
  }
</style>